import { useKernel } from '../../kernel/kernelHooks';
import { RoutingService } from './routingService';

export function useRoutingService(): RoutingService {
  const kernel = useKernel();
  return kernel.store.routingService;
}